export const sampleData = [
    {
        type: 'line',
        id: 'fund',
        zIndex: 2,
        name: 'Innovator U.S. Equity Ultra Buffer ETF (UJAN)',
        color: '#236b72',
        data: [
            {
                x: Date.UTC(2023, 11, 31),
                y: 0.0,
                fundPrice: 36.54,
                remainingCap: 13.94,
                remainingCapNet: 13.94,
                remainingBuffer: 30.48,
                remainingBufferNet: 30.12,
                downsideBeforeBuffer: 10.91,
                downsideBeforeBufferNet: 11.12,
                remainingOutcomePeriod: 216,
                spyLevel: 512.85,
                spyReturn: 6.85,
                qqqLevel: 512.85,
                qqqReturn: 6.85,
                remainingProtection: 30.48,
                remainingProtectionNet: 30.12,
                downsideBeforeFloor: 10.91,
                downsideBeforeFloorNet: 11.12,
            },
            {
                x: Date.UTC(2024, 1, 2),
                y: 10.5,
                fundPrice: 36.54,
                remainingCap: 13.94,
                remainingCapNet: 13.94,
                remainingBuffer: 30.48,
                remainingBufferNet: 30.12,
                downsideBeforeBuffer: 10.91,
                downsideBeforeBufferNet: 11.12,
                remainingOutcomePeriod: 216,
                spyLevel: 512.85,
                spyReturn: 6.85,
                qqqLevel: 512.85,
                qqqReturn: 6.85,
                remainingProtection: 30.48,
                remainingProtectionNet: 30.12,
                downsideBeforeFloor: 10.91,
                downsideBeforeFloorNet: 11.12,
            },
            {
                x: Date.UTC(2024, 2, 3),
                y: 12,
                // @ts-ignore
                fundPrice: 36.54,
                remainingCap: 13.94,
                remainingCapNet: 13.94,
                remainingBuffer: 30.48,
                remainingBufferNet: 30.12,
                downsideBeforeBuffer: 10.91,
                downsideBeforeBufferNet: 11.12,
                remainingOutcomePeriod: 216,
                spyLevel: 512.85,
                spyReturn: 6.85,
                remainingProtection: 30.48,
                remainingProtectionNet: 30.12,
                downsideBeforeFloor: 10.91,
                downsideBeforeFloorNet: 11.12,
            },
            {
                x: Date.UTC(2024, 3, 4),
                y: 11,
                fundPrice: 36.54,
                remainingCap: 13.94,
                remainingCapNet: 13.94,
                remainingBuffer: 30.48,
                remainingBufferNet: 30.12,
                downsideBeforeBuffer: 10.91,
                downsideBeforeBufferNet: 11.12,
                remainingOutcomePeriod: 216,
                spyLevel: 512.85,
                spyReturn: 6.85,
                qqqLevel: 512.85,
                qqqReturn: 6.85,
                remainingProtection: 30.48,
                remainingProtectionNet: 30.12,
                downsideBeforeFloor: 10.91,
                downsideBeforeFloorNet: 11.12,
            },
            {
                x: Date.UTC(2024, 4, 5),
                y: -2,
                fundPrice: 36.54,
                remainingCap: 13.94,
                remainingCapNet: 13.94,
                remainingBuffer: 30.48,
                remainingBufferNet: 30.12,
                downsideBeforeBuffer: 10.91,
                downsideBeforeBufferNet: 11.12,
                remainingOutcomePeriod: 216,
                spyLevel: 512.85,
                spyReturn: 6.85,
                qqqLevel: 512.85,
                qqqReturn: 6.85,
                remainingProtection: 30.48,
                remainingProtectionNet: 30.12,
                downsideBeforeFloor: 10.91,
                downsideBeforeFloorNet: 11.12,
            },
            {
                x: Date.UTC(2024, 5, 6),
                y: 12.5,
                fundPrice: 36.54,
                remainingCap: 13.94,
                remainingCapNet: 13.94,
                remainingBuffer: 30.48,
                remainingBufferNet: 30.12,
                downsideBeforeBuffer: 10.91,
                downsideBeforeBufferNet: 11.12,
                remainingOutcomePeriod: 216,
                spyLevel: 512.85,
                spyReturn: 6.85,
                qqqLevel: 512.85,
                qqqReturn: 6.85,
                remainingProtection: 30.48,
                remainingProtectionNet: 30.12,
                downsideBeforeFloor: 10.91,
                downsideBeforeFloorNet: 11.12,
            },
        ],
        marker: { symbol: 'dot', radius: 3 },
        lineWidth: 2,
    },

    {
        type: 'line',
        id: 'index',
        zIndex: 2,
        name: 'Innovator U.S. Equity Ultra Buffer ETF (UJAN)',
        color: '#84d0d9',
        data: [
            {
                x: Date.UTC(2023, 11, 31),
                y: 0.2,
                fundPrice: 36.54,
                remainingCap: 13.94,
                remainingCapNet: 13.94,
                remainingBuffer: 30.48,
                remainingBufferNet: 30.12,
                downsideBeforeBuffer: 10.91,
                downsideBeforeBufferNet: 11.12,
                remainingOutcomePeriod: 216,
                spyLevel: 512.85,
                spyReturn: 6.85,
                remainingProtection: 30.48,
                remainingProtectionNet: 30.12,
                downsideBeforeFloor: 10.91,
                downsideBeforeFloorNet: 11.12,
            },
            {
                x: Date.UTC(2024, 1, 2),
                y: 6,
                fundPrice: 36.54,
                remainingCap: 13.94,
                remainingCapNet: 13.94,
                remainingBuffer: 30.48,
                remainingBufferNet: 30.12,
                downsideBeforeBuffer: 10.91,
                downsideBeforeBufferNet: 11.12,
                remainingOutcomePeriod: 216,
                spyLevel: 512.85,
                spyReturn: 6.85,
                remainingProtection: 30.48,
                remainingProtectionNet: 30.12,
                downsideBeforeFloor: 10.91,
                downsideBeforeFloorNet: 11.12,
            },
            {
                x: Date.UTC(2024, 2, 3),
                y: -0.94,
                fundPrice: 36.54,
                remainingCap: 13.94,
                remainingCapNet: 13.94,
                remainingBuffer: 30.48,
                remainingBufferNet: 30.12,
                downsideBeforeBuffer: 10.91,
                downsideBeforeBufferNet: 11.12,
                remainingOutcomePeriod: 216,
                spyLevel: 512.85,
                spyReturn: 6.85,
                remainingProtection: 30.48,
                remainingProtectionNet: 30.12,
                downsideBeforeFloor: 10.91,
                downsideBeforeFloorNet: 11.12,
            },
            {
                x: Date.UTC(2024, 3, 4),
                y: 4,
                fundPrice: 36.54,
                remainingCap: 13.94,
                remainingCapNet: 13.94,
                remainingBuffer: 30.48,
                remainingBufferNet: 30.12,
                downsideBeforeBuffer: 10.91,
                downsideBeforeBufferNet: 11.12,
                remainingOutcomePeriod: 216,
                spyLevel: 512.85,
                spyReturn: 6.85,
                remainingProtection: 30.48,
                remainingProtectionNet: 30.12,
                downsideBeforeFloor: 10.91,
                downsideBeforeFloorNet: 11.12,
            },
            {
                x: Date.UTC(2024, 4, 5),
                y: -0.97,
                fundPrice: 36.54,
                remainingCap: 13.94,
                remainingCapNet: 13.94,
                remainingBuffer: 30.48,
                remainingBufferNet: 30.12,
                downsideBeforeBuffer: 10.91,
                downsideBeforeBufferNet: 11.12,
                remainingOutcomePeriod: 216,
                spyLevel: 512.85,
                spyReturn: 6.85,
                remainingProtection: 30.48,
                remainingProtectionNet: 30.12,
                downsideBeforeFloor: 10.91,
                downsideBeforeFloorNet: 11.12,
            },
            {
                x: Date.UTC(2024, 5, 6),
                y: 2,
                fundPrice: 36.54,
                remainingCap: 13.94,
                remainingCapNet: 13.94,
                remainingBuffer: 30.48,
                remainingBufferNet: 30.12,
                downsideBeforeBuffer: 10.91,
                downsideBeforeBufferNet: 11.12,
                remainingOutcomePeriod: 216,
                spyLevel: 512.85,
                spyReturn: 6.85,
                remainingProtection: 30.48,
                remainingProtectionNet: 30.12,
                downsideBeforeFloor: 10.91,
                downsideBeforeFloorNet: 11.12,
            },
        ],
        marker: { symbol: 'dot', radius: 3 },
        lineWidth: 2,
    },
];
